// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ReleaseNoteReactionsResponse

export type ReleaseNoteReactionsApiResponse = {
	thumbs_up: number;
	thumbs_down: number;
	heart: number;
};

export type ReleaseNoteReactions = {
	thumbs_up: number;
	thumbs_down: number;
	heart: number;
};

export function hydrateReleaseNoteReactions(data: ReleaseNoteReactionsApiResponse): ReleaseNoteReactions {
	return { ...data };
}